import { parsePLPURL } from "@tvg/product-listing-url";
import { ASResponse, SearchResponse } from "types/searchApi/response";
import { MIN_INPUT_LEN_FOR_API_CALL } from "./constants";

export const memoizeFunc = <F extends () => unknown>(
  func: F,
): (() => ReturnType<F>) => {
  let cache: ReturnType<F>;
  return () => {
    if (cache) return cache;
    cache = func() as ReturnType<F>;
    return cache;
  };
};

export const isValidASTerm = (term?: string): term is string =>
  Boolean(term && term.length >= MIN_INPUT_LEN_FOR_API_CALL);

export const getSearchHREF = (term: string) =>
  parsePLPURL(`/search/${term.toLowerCase()}`).href;

export const formatResponse = (
  res: SearchResponse | ASResponse | null,
  isRecommendations: boolean,
  recentSearches?: string[],
  searchedTerm?: string,
) =>
  !res?.response
    ? {
        searchedTerm,
        searches: { recent: recentSearches },
        isRecommendations,
      }
    : {
        searchedTerm,
        products: res.response.product_list,
        brands: res.response.autosuggest?.brands,
        searches: {
          recent: recentSearches,
          suggested: res.response.autosuggest?.suggestions,
        },
        isRecommendations,
        recommendationsData: {
          popularSuggestions: {
            podId: res.response.recs?.suggestionsMeta?.pod?.id,
            resultId: res.response.recs?.suggestionsMeta?.result_id,
            numResults: res.response.recs?.suggestionsMeta?.num_results,
            strategyIds: res.response.recs?.suggestionStrategyIds,
          },
          popularProducts: {
            podId: res.response.recs?.productsMeta?.pod?.id,
            resultId: res.response.recs?.productsMeta?.result_id,
            numResults: res.response.recs?.productsMeta?.num_results,
          },
        },
      };

export const sanitizeInput = (searchTerm: string | undefined) => {
  const pattern = /[^\w]|_/g;
  return searchTerm
    ? searchTerm.replace(pattern, " ").replace(/\s+/g, " ").trim()
    : "";
};

export const isSFLVeryIEHeaderEnabled = (userAgent: string | undefined) =>
  typeof userAgent === "string" && userAgent.includes("-S4L-SKYSCAPE");
